import { useContext } from 'react'
import { Link } from 'react-router-dom'
import { Row, Col, ListGroup } from 'react-bootstrap'
import { PlayFill } from 'react-bootstrap-icons'
import { getAlbumUrl } from '../../api/api.cdlbt.co'
import { PlayerContext } from '../../pages/Home'

const RecordingTableItem = ({ hide = [], recording, index, playFn }) => {
  const { playRecordings } = useContext(PlayerContext)

  if (!recording) return ''

  const recordingLink = `/recording/${recording.name}`
  const bodyMakeLink = `/body/${recording.vehicle.body.partMake.makeId}`
  const bodyLink = `${bodyMakeLink}/${recording.vehicle.body.partId}`
  const chassisMakeLink = `/chassis/${recording.vehicle.chassis.partMake.makeId}`
  const chassisLink = `${chassisMakeLink}/${recording.vehicle.chassis.partId}`
  const gearboxMakeLink = `/gearbox/${recording.vehicle.gearbox.partMake.makeId}`
  const gearboxLink = `${gearboxMakeLink}/${recording.vehicle.gearbox.partId}`
  const operatorLink = `/operator/${recording.vehicle.op.opId}`

  return (
    <ListGroup.Item>
      <Row className='ps-1 pe-2'>
        <Col
          xs={1}
          className='d-flex flex-column justify-content-center ps-0 pe-0 ms-2 me-2'
        >
          <img
            className={`rounded ${recording.vehicle.chassis.partMake.makeId} ${
              recording.hd ? 'recording-card-img-hd' : ''
            }`}
            src={getAlbumUrl(
              recording.vehicle.body.partMake.makeId,
              recording.vehicle.body.partId
            )}
            alt={recording.name}
          />
        </Col>
        <Col className='d-flex flex-column justify-content-center'>
          <small className='d-block text-truncate'>
            {recording.vehicle.op?.opName}
            {recording.vehicle.fleetNo ? ` - ${recording.vehicle.fleetNo}` : ''}
          </small>
          <h5 className='mb-0 fw-bold'>
            <Link className='reg'>
              {recording.vehicle.regName}
            </Link>
          </h5>
          <small className='mb-1 text-truncate'>
            {!hide.includes('chassis') && (
              <>
                {recording.vehicle.chassis.partMake?.makeName}{' '}
                {recording.vehicle.chassis.partName}
                {' - '}
              </>
            )}
            {!hide.includes('gearbox') && (
              <>
                {recording.vehicle.gearbox.partMake?.makeName}{' '}
                {recording.vehicle.gearbox.partName}
                {' - '}
              </>
            )}
            {!hide.includes('body') && (
              <>
                {recording.vehicle.body.partMake?.makeName}{' '}
                {recording.vehicle.body.partName}
              </>
            )}
          </small>
        </Col>

        <Col xs={1} className='d-flex flex-column justify-content-center'>
          <button
            className='btn p-0 recording-item-play'
            onClick={() => playFn(index)}
          >
            <PlayFill className='w-100' size={24} />
          </button>
        </Col>
      </Row>
    </ListGroup.Item>
  )
}
export default RecordingTableItem
